export enum OpenMode {
  Standard,
  Modal,
  NewTab,
}
